import api from '../store/apiClient';

function unwrap(payload) {
  return payload?.data !== undefined ? payload.data : payload;
}

export const authService = {
  login: async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    return unwrap(data);
  },

  register: async (body) => {
    const { data } = await api.post('/auth/register', body);
    return unwrap(data);
  },

  getMe: async () => {
    const { data } = await api.get('/auth/me');
    return unwrap(data);
  },

  logout: async () => {
    /* JWT is abandoned client-side unless you add blacklist */
  },
};
